// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class OrderPaymentMethod extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Methods = {
    COD: 4,
    WinterProgramTerms: 5,
    Northpoint: 6,
    NET30: 7,
    ACH: 8,
    InvoiceDealer: 9
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  name?: string;
}

